/**
 * Tenant resolution.
 *
 * The dashboard does NOT derive the tenant from the browser host. Businesses
 * are spread across several Application servers, and sign-in reports which one
 * holds each; picking a business points the tenant client at its server
 * (e.g. https://svr2.ninos-home.me). Directory calls — the account itself, its
 * businesses, its invitations — go to MainApp instead.
 *
 * Kept here rather than in the store because the PocketBase client is built
 * before the store has rehydrated.
 */

const TENANT_URL_KEY = "manito.tenantApiUrl";

export function getTenantApiUrl(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(TENANT_URL_KEY);
}

export function setTenantApiUrl(url: string): void {
  window.localStorage.setItem(TENANT_URL_KEY, url);
}

export function clearTenantApiUrl(): void {
  window.localStorage.removeItem(TENANT_URL_KEY);
}
